export class DanhSachNgayNghi {
    "idLoaiNgayNghi": string;
    "ten": string;
    "ngay": Date;
}

export class NgayNghi {
    'id': number;
    'lyDo': string;
    'tenLoaiNgayNghi': string;
    'ghiChu': string;
    'heSo': number;
    'idLoaiNgayNghi': number;
    'tuNgay': Date;
    'denNgay': Date;
    'lapHangNam': number;
}

export class ChiTietNgayNghi {
    'id': number;
    'lyDo': string;
    'ghiChu': string;
    'heSo': number;
    'idLoaiNgayNghi': number;
    'tuNgay': Date;
    'denNgay': Date;
    'lapHangNam': number;
}

export class DsNgayNghi {
    'danhSachNgayNghi': Array<NgayNghi>;
}

export class DsNgayNghiPagingResponse {
    "data": Array<NgayNghi>;
    "recordsTotal": number;
    "maxPage": number;
    "pageCurrent": number;
    "pageListShow": Array<number>;
}